// Ensure that we switch the base HREF between development and production.
export const getBaseHref = () =>
  process.env.NODE_ENV === 'development' ? process.env.NX_PUBLIC_URL_OFFSET || '/' : '/CASOps';
